import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { middle } from '../../copy/ecap/classesSetupCopy.json';
import { coreSubjectsEn } from '../../copy/ecap/classesSetupStrings';
import { progressBarsStatus } from '../ecap/classes/drag-drop/dragDropUtil';

export default function CareerCardBubble(props) {
  const getMasterProgress = () => {
    let masterProgress = 0;

    Object.values(coreSubjectsEn).map((subject) => {
      const result = progressBarsStatus(
        props.placedClasses,
        subject,
        props.progressByDegree
      );
      masterProgress += result;
      return masterProgress;
    });

    return masterProgress;
  };

  const value = (getMasterProgress() / props.totalRequiredClasses) * 100;

  return (
    <div
      style={{ width: 50, height: 50 }}
      className="career-card-bubble-container"
    >
      <CircularProgressbar
        styles={buildStyles({
          textColor: 'black',
          trailColor: '#E8E8E8',
          strokeLinecap: 'butt',
          textSize: '24px',
          pathColor: `${props.color}`,
        })}
        value={value}
        maxValue={100}
        text={`${getMasterProgress()}/${props.totalRequiredClasses}`}
      />
    </div>
  );
}

CareerCardBubble.propTypes = {
  color: PropTypes.string.isRequired,
  totalRequiredClasses: PropTypes.number.isRequired,
};
